// Reads the GA4 client_id out of the `_ga` cookie gtag.js sets. The cookie
// value looks like `GA1.1.<client_id_part1>.<client_id_part2>`; the
// Measurement Protocol client_id is the last two dot-separated segments.
// Used to stitch server-side payment_success sends back to the browser
// session that clicked the ad, instead of showing up as unattributed traffic.
export function getGa4ClientIdFromCookie(): string | null {
  if (typeof document === "undefined") {
    return null;
  }

  const match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);

  if (!match) {
    return null;
  }

  const parts = decodeURIComponent(match[1]).split(".");

  if (parts.length < 4) {
    return null;
  }

  return `${parts[2]}.${parts[3]}`;
}
